import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { UserManagementData } from "../../../domain/models/user-management/user-management-data";
import { FetchUserManagementData } from "../../../domain/useages/user-management/fetch-user-management-data";
import { RemoteFetchUserManagementData } from "../../../data/usecases/user-management/remote-fetch-user-management-data";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { UserManagementFilters } from "../../../domain/models/user-management/user-management-filters";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchUserManagementDataInterface {
  fetchUserManagementData: Function;
  userManagementData: UserManagementData[];
  userManagementDataStatus: FetchState;
  filterStore: UserManagementFilters;
  DataLength: number;
  setReportingLockedState: () => void;
}

const initialStates = {
  userManagementData: [],
  userManagementDataStatus: FetchState.DEFAULT,
  filterStore: {
    reporting_locked: 0,
    page: 1,
    length: 10,
    status: "active",
  } as UserManagementFilters,
  DataLength: 0,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useUserManagementDataSlice: StateCreator<
  FetchUserManagementDataInterface
> = (set, get) => ({
  ...initialStates,

  setReportingLockedState: () => {
    const currentLock = get().filterStore.reporting_locked;
    const newLock = currentLock === 1 ? 0 : 1; 
    set((state) => ({
      filterStore: {
        ...state.filterStore,
        reporting_locked: newLock,
      },
    }));
  },

  fetchUserManagementData: async () => {
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchCustomerTypes: FetchUserManagementData =
      new RemoteFetchUserManagementData(
        `${BASE_URL}${Endpoints.FETCH_USER_MANAGEMENT_DATA}`,
        axiosHttpClient
      );

    let filters = {
      role_id: get().filterStore.role_id,
      status: get().filterStore.status,
      zone_id: get().filterStore.zone_id,
      region_id: get().filterStore.region_id,
      area_id: get().filterStore.area_id,
      search: get().filterStore.search,
      length: get().filterStore.length,
      page: get().filterStore.page,
      reporting_locked:
        get().filterStore.reporting_locked === 1 ? 1 : undefined,
    };

    set(() => ({ userManagementDataStatus: FetchState.LOADING }));

    let result = await remoteFetchCustomerTypes.fetch(filters);
    if (result) {
      set(() => ({ userManagementData: result.users }));
      set(() => ({ DataLength: result.total }));
      set(() => ({ userManagementDataStatus: FetchState.SUCCESS }));
    }
  },
});
